import Slider from '$store/components/ui/Slider.tsx'
import SliderJS from '$store/islands/SliderJS.tsx'
import { SimilarProduct } from '$store/sdk/useSimilars.ts'

import { groupBy } from 'std/collections/group_by.ts'
import { useId } from 'site/sdk/useId.ts'
import { Texts } from 'site/components/product/ProductDetails.tsx'
import Image from 'apps/website/components/Image.tsx'
import Icon from 'site/components/ui/Icon.tsx'
import c from 'site/sdk/c.ts'
import { sendEvent } from 'site/sdk/analytics.ts'
import { mapProductToAnalyticsItem } from 'site/utils/productToAnalyticsItem.ts'

export type SimilarsProps = {
    similars: SimilarProduct[]
    texts?: Texts
    layout?: 'buyModal' | 'productDetailsVariant'
    currentProduct?: SimilarProduct
}

const Similars = ({ similars, texts, currentProduct, layout }: SimilarsProps) => {
    const colorsId = useId()
    if (similars.length === 0) {
        return null
    }
    similars = similars.filter((similar) => similar.IsAvailable)
    if (similars.length === 0) {
        return null
    }
    const similarsByColor = groupBy(similars, (similars) => similars.color as string)
    const isModalBuy = layout === 'buyModal'
    const isProductDetailsVariant = layout === 'productDetailsVariant'

    return (
        <>
            {Object.keys(similarsByColor).length && (
                <>
                    <div class={c(!isModalBuy && 'my-8 md:max-w-[440px]')} id={colorsId}>
                        {texts && (
                            <span class='block mb-2 text-xs text-neutral-1'>
                                {isProductDetailsVariant
                                    ? (
                                        <>
                                            {'Cor: '}
                                            <strong>
                                                {currentProduct?.color}
                                            </strong>
                                        </>
                                    )
                                    : texts.similarColorsText}
                            </span>
                        )}

                        <div class='flex items-center relative'>
                            <Slider class='carousel flex w-full'>
                                {[
                                    isProductDetailsVariant ? currentProduct : undefined,
                                    ...Object.values(similarsByColor)
                                        .flat(2),
                                ]
                                    .map((similar, index) => {
                                        if (!similar) {
                                            return null
                                        }
                                        const { imageUrl, url, color, price, listPrice } = similar

                                        return (
                                            <Slider.Item
                                                class='carousel-item shrink-0 overflow-hidden'
                                                index={index}
                                            >
                                                <button
                                                    type='button'
                                                    onClick={() => {
                                                        // Motivo da remoção: O evento é disparado quando o produto é carregado, portanto não é necessário disparar ao clicar
                                                        //
                                                        //     const event = {
                                                        //         name: 'view_item',
                                                        //         params: {
                                                        //             currency: 'BRL',
                                                        //             value: price,
                                                        //             items: [
                                                        //                 mapProductToAnalyticsItem({
                                                        //                     product: {
                                                        //                         '@type': 'Product',
                                                        //                         name: similar.name,
                                                        //                         productID:
                                                        //                             similar.productId,
                                                        //                         sku: similar.productId,
                                                        //                         isVariantOf: {
                                                        //                             '@type':
                                                        //                                 'ProductGroup',
                                                        //                             name: similar.name,
                                                        //                             productGroupID:
                                                        //                                 similar
                                                        //                                     .productId,
                                                        //                             additionalProperty:
                                                        //                                 [],
                                                        //                             hasVariant: [],
                                                        //                         },
                                                        //                     },
                                                        //                     index: 0,
                                                        //                     price,
                                                        //                     listPrice,
                                                        //                 }),
                                                        //             ],
                                                        //         },
                                                        //     }

                                                        //     sendEvent(event)

                                                        //     console.log('disparando evento', event)
                                                    }}
                                                >
                                                    <a
                                                        href={url.replace(/[?&]skuId=\d+/, '')}
                                                        onClick={(e) => {
                                                            if (
                                                                currentProduct?.productId ===
                                                                    similar.productId
                                                            ) e.preventDefault()
                                                        }}
                                                        class='flex items-center justify-start flex-col px-2 first:pl-0 '
                                                    >
                                                        <Image
                                                            class={c(
                                                                currentProduct?.productId ===
                                                                        similar.productId &&
                                                                    'border border-primary-700',
                                                            )}
                                                            src={imageUrl}
                                                            width={isModalBuy ? 36 : 58}
                                                            height={isModalBuy ? 45 : 72}
                                                        />
                                                        <p class='text-xs text-neutral-1 mt-1'>
                                                            {color}
                                                        </p>
                                                    </a>
                                                </button>
                                            </Slider.Item>
                                        )
                                    })}
                            </Slider>

                            <div
                                class={c(
                                    !isModalBuy &&
                                        'flex justify-center items-center absolute left-0',
                                    isModalBuy &&
                                        'flex justify-center items-center absolute left-[-25px]',
                                )}
                            >
                                <Slider.PrevButton class='p-3 disabled:hidden' disabled>
                                    <Icon
                                        width={12}
                                        height={12}
                                        id='ChevronLeft'
                                        strokeWidth={3}
                                        class='text-black transition-opacity disabled:opacity-50'
                                    />
                                </Slider.PrevButton>
                            </div>
                            <div
                                class={c(
                                    !isModalBuy &&
                                        'flex justify-center items-center absolute right-0',
                                    isModalBuy &&
                                        'flex justify-center items-center absolute right-[-25px]',
                                )}
                            >
                                <Slider.NextButton class='p-3 disabled:hidden' disabled>
                                    <Icon
                                        width={12}
                                        height={12}
                                        id='ChevronRight'
                                        strokeWidth={3}
                                        class='text-black'
                                    />
                                </Slider.NextButton>
                            </div>
                        </div>
                    </div>
                    <SliderJS rootId={colorsId} />
                </>
            )}
        </>
    )
}

export default Similars
